import { EncryptStorage } from 'encrypt-storage';

const encryptStorage = new EncryptStorage(
	(process.env.REACT_APP_SECRET_KEY || 'YOUR_SECRET_KEY')?.toString(),
	{
		storageType: 'sessionStorage',
	},
);

const storageWrapper = {
	getStorageItem: (item: string) => encryptStorage.getItem(item),
	setStorageItem: (key: string, value: any) =>
		encryptStorage.setItem(key, value),
	clearStorage: () => encryptStorage.clear(),
};

export default storageWrapper;
